import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=c4e58b3c&scoped=true"
import script from "./IconTextButton.vue?vue&type=script&lang=ts"
export * from "./IconTextButton.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/scoped/icon-text-button-style.css?vue&type=style&index=0&id=c4e58b3c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e58b3c",
  null
  
)

export default component.exports